import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

export const LoadingOverlay = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ w: "100%", h: "100%", minHeight: "360px" }}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};
